var parentSelector =
    '.mytyFormTextBox, .mytyFormSelectBox, .mytyUIDatePickerBox,' +
    '.mytyFormPasswordBox, .mytyFormCurrentPasswordBox, .mytyFormPasswordValidationBox,' +
    '.mytyFormCaptchaBox, .mytyFormTextAreaBox, .mytyFormRichtextBox'; // not .linkCaption with prepend addon

var floatingLabels = {
    init: function() {
        $(document.body).on('focus change input','.mytyFormControl, .select2-search__field',function(event) {
            var $parent = $(this).closest(parentSelector);
            $parent.removeClass('is-default');
            if (event.type == 'focusin' && !this.hasAttribute('readonly') && !this.hasAttribute('disabled')) {
                $parent.addClass('is-focused');
            }
        });
        $(document.body).on('click','.mytyFormRichtextBox',function() { // fix: focus richtext edits on label
            $(this).find('.fr-element.fr-view').trigger('focus')
        });

        // wont fix: missing event bubbling on label >> only disabled in admin view, to allow for editing

        $(document.body).on('focusout','.mytyFormControl:not(".select2-hidden-accessible"), .select2-search__field',function(event) {
            var $self = $(this);
            var $parent = $self.closest(parentSelector);

            $parent.removeClass('is-focused');
            setTimeout(function(){
                var curVal = $self.val() || $parent.find('.select2-hidden-accessible').val() || $parent.find('.tyFormHidden').val();
                // wait, value might be changed by myty widget code (datepicker)
                if (!curVal) $parent.addClass('is-default');
            },200);
        });
    },
    set: function() {
        // Set label position when filled
        $(parentSelector).find('.mytyFormControl:not(".select2-hidden-accessible"), .select2-search__field').each(function(i,e) {
            if ($(this).val() != '') {
                $(this).closest(parentSelector).removeClass('is-default');
            } else {
                $(this).closest(parentSelector).addClass('is-default');
            }
        });

        // Fix multiline underline with descriptions
        $('.mytyFormRichtextBox, .mytyFormTextAreaBox').each(function() {
            var $description = $(this).find('.mytyFormElementDescription');
            if ($description.length) {
                $(this).css('margin-bottom', $description.outerHeight() + 20);
                $description.css('position', 'absolute')
            }
        });
    }
};
floatingLabels.set();
floatingLabels.init();
$(document).ready(function() {
    floatingLabels.set(); // set again in case value has changed
});

// autosize
if (typeof autosize !== 'undefined') {
    autosize(document.querySelectorAll('.mytyFormTextAreaBox .mytyFormControl'));
}
